import React from 'react'
import TopPanelMenu from 'components/TopPanelMenu'

export default class extends React.Component {
  render() {
    return (
      <TopPanelMenu
        items={[
          {to: '/cross-site/costs-overview/cost-per-visit', title: 'Cost Per Visit'},
          {to: '/cross-site/costs-overview/cost-per-conversion', title: 'Cost Per conversion'}
        ]}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./client/views/CostsView/crossmenu.js